import { Message } from 'element-ui';
// 记录加载初始化状态
let isSdkReady = false;

// 记录加载配置状态
let isConfig = false;

export default {
  /**
   * @desc 初始化 七鱼客服
   * @param {function} fn
   */
  init (fn) {
    window.ysf('onready', function () {
      isSdkReady = true;
      if (fn) fn();
    });
  },

  /**
   * @desc 注销帐号
   */
  logoff () {
    window.ysf('logoff');
  },

  /**
   * @desc 配置客户参数
   * @param {string} userId
   * @param {string} userName
   */
  setConfig ({ userId, userName }) {
    window.ysf('config', {
      uid: userId,
      name: userName,
      success () {
        isConfig = true;
      }
    });
  },

  /**
   * @desc 打开客服弹框
   */
  openSdk () {
    if (isSdkReady && isConfig) {
      window.ysf('open');
    } else {
      Message.warning('小爱客服还没有准备好~，请您稍等再点');
    }
  }
};
